export const CommonVipBadgeType = {
  /**
   * 골드 클래스
   */
  GOLD: 'GOLD',
  /**
   * 해외숙소 항공특가
   */
  FLIGHT: 'FLIGHT',
} as const

export type TCommonVipBadgeType = (typeof CommonVipBadgeType)[keyof typeof CommonVipBadgeType]
